import { render, staticRenderFns } from "./TreePassport.vue?vue&type=template&id=256dc7e6&scoped=true"
import script from "./TreePassport.vue?vue&type=script&lang=js"
export * from "./TreePassport.vue?vue&type=script&lang=js"
import style0 from "./TreePassport.vue?vue&type=style&index=0&id=256dc7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256dc7e6",
  null
  
)

export default component.exports